(function () {
    'use strict';

    angular.module("imApp").factory("deliveryTermsService", ['$ihttp', function ($ihttp) {
        let service = {
            listDeliveryTerms: function (parms) {
                return $ihttp.post({
                    method: 623,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
